import create from 'zustand';

export const useAuthStore = create(set => ({
    currentUser: null,
    isAuthenticated: null,
    setCurrentUser:(user)  => set((state) => ({ currentUser: user })),
    logout: () => set({ currentUser: null, isAuthenticated: false }),
    logIn: (user) => set({currentUser:user,isAuthenticated:true})
  }));